import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Loader from '../../Component/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { setOutlookAuthenticated } from '../../store/auth/authSlice';
import { apiUrl } from '../../config/apiUrl';

/**
 * OutlookCallback component handles the OAuth callback from Outlook.
 * It exchanges the authorization code for an access token, stores authentication state,
 * and redirects the user based on the result.
 *
 * @component
 */
const OutlookCallback = () =>
{
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const accessToken = useSelector( ( state ) => state?.authReducer?.access_token );
  useEffect( () =>
  {
    const query = new URLSearchParams( location.search );
    const code = query.get( 'code' ) ?? '';
    const state = query.get( 'state' );
    const redirectPage = sessionStorage.getItem( 'outlook-redirect-page' ) || '/zoom';
    const finish = ( ok ) =>
    {
      sessionStorage.removeItem( 'outlook-redirect-page' );
      dispatch( setOutlookAuthenticated( ok ) );
      navigate( ok ? redirectPage : `${ redirectPage }?error=1`, { replace: true } );
    };

    // Microsoft's code works once. Send each code once (a reload of this page must not
    // send it again), but never block a new sign-in: the old one-time flag stayed set
    // for the whole tab, so a second attempt sat on this loader forever.
    if ( !code || !state ) return finish( false );
    if ( sessionStorage.getItem( 'outlook-code-sent' ) === code ) return navigate( redirectPage, { replace: true } );
    sessionStorage.setItem( 'outlook-code-sent', code );

    axios
      .get( `${ apiUrl }/outlook/redirect`, {
        params: { code, state },
        headers: { Authorization: `Bearer ${ accessToken }` },
        timeout: 60000,
      } )
      .then( ( res ) => finish( !!res?.data?.success ) )
      .catch( ( error ) =>
      {
        console.error( 'Outlook sign-in failed:', error?.response?.data || error?.message );
        finish( false );
      } );
  }, [] );

  return <Loader />;
};

export default OutlookCallback;